import React from "react";
import { useParams } from "react-router-dom";

export default function Email() {
  const email = useParams().email;

  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const PS = process.env.REACT_APP_PUBLIC_SERVER;

  return (
    <>
      <div className="auth-fluid">
        <div className="auth-fluid-form-box">
          <div className="align-items-center d-flex h-100">
            <div className="card-body">
              <div className="auth-brand text-center text-lg-end">
                <a href="index.html" className="logo-light">
                  <span>
                    <img
                      src={PS + "logo.png"}
                      alt=""
                      height="80"
                      style={{ marginTop: "-40px", marginLeft: "-60px" }}
                    />
                  </span>
                </a>
              </div>
              <div className="text-center m-auto">
                <img
                  src="assets/images/mail_sent.svg"
                  alt="mail sent image"
                  height="64"
                />
                <h4 className="text-dark-50 text-center mt-4 fw-bold">
                  Por favor verifique seu email
                </h4>
                <p className="text-muted mb-4">
                  Um e-mail foi enviado para {email} Verifique se há um e-mail
                  da Emainvest e clique no link para confirmar sua conta.
                </p>
              </div>

              <form action={PF + "login"}>
                <div className="mb-0 d-grid text-center">
                  <button className="btn btn-primary" type="submit">
                    <i className="uil uil-user"></i> Login
                  </button>
                </div>
              </form>

              <footer className="footer footer-alt">
                <p className="text-muted">
                  Faça ja o
                  <a href={PF + "login"} className="text-muted ms-1">
                    <b>Login</b>
                  </a>
                </p>
              </footer>
            </div>
          </div>
        </div>

        <div className="auth-fluid-right text-center">
          <div className="auth-user-testimonial">
            <h2 className="mb-3">EmaInvest</h2>
            <p className="lead">
              <i className="mdi mdi-format-quote-open"></i> Ser rico não é um
              privilégio. Ser rico é um direito. Se você criar grande valor para
              os outros, você tem o direito de ser tão rico quanto quiser
              <i className="mdi mdi-format-quote-close"></i>
            </p>
            <p>- Steve Siebold</p>
          </div>
        </div>
      </div>
    </>
  );
}
